import { useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { currencyFormat } from "../../../helpers/numericFields";
import { EditPaymentWholesaler } from "./EditPaymentWholesaler";
import styles from './PaymentToWholesalerDetails.module.css'
import { ModalPaymentImage } from "../../ui/controls/ModalPaymentImage";

export const PaymentToWholesalerDetails = ({ masterSaleGroup, code }) => {
  const { role } = useSelector((state) => state.auth);
  const [editPaymentWholesaler, setEditPaymentWholesaler] = useState(false);
  const [paymentSelected, setPaymentSelected] = useState({});

  const [viewImage, setViewImage] = useState(false);

  const edit2 = (payment) => {
    setEditPaymentWholesaler(true);
    setPaymentSelected(payment);
  }

  const viewImage2 = (payment) => {
    setViewImage(true);
    setPaymentSelected(payment);
  }

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className="table-responsive">
        <Table className="table border text-nowrap mg-b-0">
          <thead>
            <tr>
              <th>Pago #</th>
              <th>Fecha</th>
              <th>Mayorista</th>
              <th>Concepto</th>
              <th>Descripcion</th>
              <th>Metodo</th>
              <th>Forma De Pago</th>
              <th>Monto</th>
              <th>Comprobante</th>
              <th>Notas</th>
              <th>Editar</th>
            </tr>
          </thead>
          <tbody>
            {
              masterSaleGroup.paymentsToWholesalerRooms.map((payment, index) => (
                <tr key={payment.id + payment.concept}>
                  <td>{index + 1}</td>
                  <td className="break-word ">{payment.date}</td>
                  <td>{payment.wholesaler}</td>
                  <td>{payment.concept}</td>
                  <td>{payment.description}</td>
                  <td>{payment.paymentMethod}</td>
                  <td>{payment.paymentWay}</td>
                  <td>{currencyFormat(payment.amount)}</td>
                  <td style={{ textAlign: "center" }}>
                    {
                      payment.image === 1
                        ? <i className={`fa fa-image ${styles.edit}`} onClick={() => viewImage2(payment)}></i>
                        : null
                    }
                  </td>
                  <td>{payment.notes}</td>
                  {
                    role === "DIRECTOR"
                    && <td style={{ textAlign: "center" }}>
                      <i className={`fe fe-edit ${styles.edit}`} onClick={() => edit2(payment)}></i>
                    </td>
                  }
                </tr>))
            }
            {
              masterSaleGroup.paymentsToWholesalerServices.map((payment, index) => (
                <tr key={payment.id + payment.service}>
                  <td>{index + 1}</td>
                  <td>{payment.date}</td>
                  <td>{payment.wholesaler}</td>
                  <td>{payment.concept}</td>
                  <td>{payment.service}</td>
                  <td>{payment.paymentMethod}</td>
                  <td>{payment.paymentWay}</td>
                  <td>{currencyFormat(payment.amount)}</td>
                  <td style={{ textAlign: "center" }}>
                    {
                      payment.image &&
                      <i className={`fa fa-image ${styles.edit}`} onClick={() => viewImage2(payment)}></i>
                    }
                  </td>
                  <td>{payment.notes}</td>
                  {
                    role === "DIRECTOR"
                    && <td style={{ textAlign: "center" }}>
                      <i className={`fe fe-edit ${styles.edit}`} onClick={() => edit2(payment)}></i>
                    </td>
                  }
                </tr>))
            }
          </tbody>
        </Table>
      </div>

      <EditPaymentWholesaler payment={paymentSelected} masterSaleGroup={masterSaleGroup}
        isOpen={editPaymentWholesaler} setIsOpen={setEditPaymentWholesaler} />
      <ModalPaymentImage code={code} id={paymentSelected.id} isOpen={viewImage} setIsOpen={setViewImage} />
      <div className={styles.total}>Total: {
        currencyFormat(
          masterSaleGroup.paymentsToWholesalerRooms.reduce((a, b) => a += b.amount, 0) +
          masterSaleGroup.paymentsToWholesalerServices.reduce((a, b) => a += b.amount, 0)
        )}
      </div>
    </div>
  )
}
